import { render, staticRenderFns } from "./PurchaseReturn.vue?vue&type=template&id=4643106d&scoped=true&"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PurchaseReturn.vue?vue&type=style&index=1&id=4643106d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643106d",
  null
  
)

export default component.exports